import TimezoneSelect, { allTimezones, ITimezone } from "react-timezone-select";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

const TIMEZONES = {
  ...allTimezones,
  "America/New_York": "New York",
};

function TimeAndTzPicker({
  hour,
  setHour,
  minute,
  setMinute,
  timeZone,
  setTimeZone,
}: {
  hour: number;
  setHour: React.Dispatch<React.SetStateAction<number>>;
  minute: number;
  setMinute: React.Dispatch<React.SetStateAction<number>>;
  timeZone: ITimezone | string;
  setTimeZone: React.Dispatch<React.SetStateAction<ITimezone | string>>;
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex items-center gap-2">
        <Label>Time (24h):</Label>
        <Input
          type="number"
          className="w-20"
          value={hour || ""} // Use empty string when 0
          onChange={(e) => {
            if (e.target.value === "") {
              setHour(0);
              return;
            }
            const val = parseInt(e.target.value, 10);
            if (isNaN(val) || val < 0 || val > 23) return;
            setHour(val);
          }}
          onBlur={(e) => {
            if (e.target.value === "") {
              setHour(0);
            }
          }}
        />
        <span>:</span>
        <Input
          type="number"
          className="w-20"
          value={minute || ""} // Use empty string when 0
          onChange={(e) => {
            if (e.target.value === "") {
              setMinute(0);
              return;
            }
            const val = parseInt(e.target.value, 10);
            if (isNaN(val) || val < 0 || val > 59) return;
            setMinute(val);
          }}
          onBlur={(e) => {
            if (e.target.value === "") {
              setMinute(0);
            }
          }}
        />
      </div>

      <div className="mt-2 md:mt-0 flex items-center gap-2">
        <Label>Timezone:</Label>
        <div className="md:w-[20rem]">
          <TimezoneSelect
            value={timeZone}
            onChange={(val) => setTimeZone(val)}
            className="timezone-select"
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                backgroundColor: "hsl(var(--background))",
                borderColor: "hsl(var(--border))",
                borderRadius: "var(--radius)",
                height: "40px",
              }),
              menu: (baseStyles) => ({
                ...baseStyles,
                backgroundColor: "hsl(var(--background))",
                borderColor: "hsl(var(--border))",
              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                backgroundColor: state.isFocused
                  ? "hsl(var(--accent))"
                  : "hsl(var(--background))",
                color: state.isFocused
                  ? "hsl(var(--accent-foreground))"
                  : "hsl(var(--foreground))",
                cursor: "pointer",
              }),
              singleValue: (baseStyles) => ({
                ...baseStyles,
                color: "hsl(var(--foreground))",
              }),
              input: (baseStyles) => ({
                ...baseStyles,
                color: "hsl(var(--foreground))",
              }),
            }}
          />
        </div>
      </div>
    </div>
  );
}

export { TimeAndTzPicker, TIMEZONES };
